import Icon, { IconName } from '@/components/atomic/icon'
import { BodySubtext, BodyXS } from '@/components/atomic/text'

interface PromptSectionProps {
  prompt: string | null
  showPrompt: boolean
  handleClick: () => void
  handleKeyDown: (e: React.KeyboardEvent) => void
  showIcon?: boolean
}

export const PromptSection = ({
  prompt,
  showPrompt,
  handleClick,
  handleKeyDown,
  showIcon = false,
}: PromptSectionProps) => {
  if (!prompt) return null
  return (
    <div className="flex flex-col w-full gap-2">
      {/** biome-ignore lint/a11y/useSemanticElements: Bulk suppression as part of biome migration */}
      <div
        className="flex gap-3 items-center text-secondary cursor-pointer"
        role="button"
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      >
        {showIcon && (
          <div className="w-5 h-5 flex justify-center items-center rounded-sm bg-tertiary-background">
            <Icon iconName={IconName.SparklesIcon} size="small" />
          </div>
        )}
        <div className="flex gap-1 items-center">
          <BodyXS>{showPrompt ? 'Hide' : 'Show'} prompt</BodyXS>
          <Icon
            iconName={
              showPrompt ? IconName.ChevronUpIcon : IconName.ChevronDownIcon
            }
            size="small"
          />
        </div>
      </div>
      {showPrompt && (
        <div className="w-full flex rounded-lg bg-tertiary-background p-1">
          <div className="w-full flex rounded-md bg-background border border-primary-border py-2 px-3">
            <BodySubtext>{prompt}</BodySubtext>
          </div>
        </div>
      )}
    </div>
  )
}
